// Thin wrapper around CircularSpinner from @khanacademy/wonder-blocks-progress-spinner

import {StyleSheet} from "aphrodite";
import * as React from "react";

import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";

type Size = "xsmall" | "small" | "medium" | "large";
type Props = {
    size: Size;
    light: boolean;
    inline?: boolean;
};

/**
 * @deprecated Use CircularSpinner from @khanacademy/wonder-blocks-progress-spinner.
 */
class DeprecatedSpinner extends React.Component<Props> {
    static defaultProps: {
        light: boolean;
        size: Size;
    } = {
        size: "large",
        light: false,
    };

    render(): React.ReactNode {
        const {size, light, inline} = this.props;

        return (
            <CircularSpinner
                size={size}
                light={light}
                style={[
                    styles.spinnerContainer,
                    inline && styles.inlineSpinnerContainer,
                ]}
            />
        );
    }
}

const styles = StyleSheet.create({
    spinnerContainer: {
        display: "flex",
        // TODO(WB-548): make CircularSpinner horizontally centered as well
        alignItems: "center",
    },
    inlineSpinnerContainer: {
        display: "inline",
    },
});

export default DeprecatedSpinner;
